<template>
    <div class="hyl">

        <img src="@/static/music.png" :class="music ? 'music zhuan' : 'music'" @click="stopmusic" alt="" />
        <audio id="audio" loop="loop" :src="require('@/static/bgm.mp3')"></audio>
        <div class="hyl-feng">
            <img src="../static/hyl_bg.jpg" class="hyl_bg" alt="">
            <img src="../static/hyl_p1.png" class="p1" @click="select = 1" alt="">
            <img src="../static/hyl_p2.png" class="p2" @click="select = 3" alt="">
            <img src="../static/hyl_p3.png" class="p3" @click="select = 2" alt="">
            <img src="../static/hyl_p4.png" class="p4" @click="select = 4" alt="">

            <img src="../static/fyt_back.png" class="fyt_back" @click="backletter" alt="">
        </div>

        <div class="hyl-p1box" v-show="select == 1">
            <img src="../static/hyl_picturebox.png" class="picturebox" alt="">
            <img src="../static/hyl_title1.png" class="title1" alt="">
            <div class="hyl_picturebox">
                <img src="../static/hyl_p1/hyl1_title.png" class="title" alt="">
                <div v-for="value in 28" style="width: 100%;">
                    <img :src="require('@/static/hyl_p1/' + value + '.jpg')" class="picture" alt="">
                </div>
                <img src="../static/back.png" class="back" @click="select = 0" alt="">
            </div>

        </div>
        <div class="hyl-p2box" v-show="select == 2">
            <img src="../static/hyl_picturebox.png" class="picturebox" alt="">
            <img src="../static/hyl_title2.png" class="title2" alt="">
            <div class="hyl_picturebox">
                <img src="../static/hyl_p2/hyl2_title.png" class="title" alt="">
                <div v-for="value in 24" style="width: 100%;">
                    <img :src="require('@/static/hyl_p2/' + value + '.jpg')" class="picture" alt="">
                </div>

                <img src="../static/back.png" class="back" @click="select = 0" alt="">
            </div>

        </div>

        <div class="hyl-p3box" v-show="select == 3">
            <img src="../static/hyl_picturebox.png" class="picturebox" alt="">
            <img src="../static/hyl_title3.png" class="title3" alt="">
            <div class="hyl_picturebox">
                <div v-for="value in 25" style="width: 100%;">
                    <img :src="require('@/static/hyl_p3/' + value + '.jpg')" class="picture" alt="">
                    <img :src="require('@/static/hyl_p3/ts' + value + '.png')" class="picturets" alt="">
                </div>

                <img src="../static/back.png" class="back" @click="select = 0" alt="">
            </div>

        </div>
        <div class="hyl-p4box" v-show="select == 4">
            <img src="../static/hyl_picturebox.png" class="picturebox" alt="">
            <img src="../static/hyl_title4.png" class="title4" alt="">
            <div class="hyl_picturebox">
                <div v-for="value in 22" style="width: 100%;">
                    <img :src="require('@/static/hyl_p4/' + value + '.jpg')" class="picture" alt="">
                      <img :src="require('@/static/hyl_p4/ts' + value + '.png')" class="picturets" alt="">
                </div>
           

                <img src="../static/back.png" class="back" @click="select = 0" alt="">
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            music: true,
            select: 0,
            numbers: Array.from({length: 16}, (v, k) => k + 9)
        }
    },
    mounted() {
        let audio = document.getElementById("audio");

        if (window.sessionStorage.getItem("music") == "false") {
            this.music = false
            audio.pause();
        } else {


            if (window.sessionStorage.getItem("time") != "null") {

                audio.currentTime = window.sessionStorage.getItem("time")
                // audio.play()
            }

            audio.play()
        }
    },
    methods: {
        stopmusic() {
            let audio = document.getElementById("audio");
            if (this.music == true) {
                this.music = false;
                audio.pause();

            } else {
                this.music = true;
                // audio.volume = 0.2;
                audio.play();
            }
        },
        backletter() {
            let audio = document.getElementById("audio");
            window.sessionStorage.setItem("time", audio.currentTime);
            window.sessionStorage.setItem("music", this.music);
            this.$router.push("map")
        },
    },
}
</script>

<style lang="less" scoped>
.hyl {
    width: 100%;

    .music {
        position: fixed;
        top: 15px;
        right: 15px;
        width: 40px;
        z-index: 3;
        transform: rotate(250deg);

        &.zhuan {
            animation: turn 2s linear infinite;

            @keyframes turn {
                0% {
                    -webkit-transform: rotate(0deg);
                }

                25% {
                    -webkit-transform: rotate(90deg);
                }

                50% {
                    -webkit-transform: rotate(180deg);
                }

                75% {
                    -webkit-transform: rotate(270deg);
                }

                100% {
                    -webkit-transform: rotate(360deg);
                }
            }
        }
    }

    .hyl-feng {
        width: 100%;
        height: 100vh;

        overflow: hidden;
        position: relative;

        .hyl_bg {
            position: absolute;
            width: 100%;
            height: 100vh;
            top: 0;
            left: 0;
            display: block;
        }

        .p1 {
            position: absolute;
            width: 200px;
            right: 0;
            top: 30px;
        }

        .p2 {
            position: absolute;
            width: 200px;
            left: 0;
            top: 130px;
        }

        .p3 {
            position: absolute;
            width: 190px;
            right: 5px;
            top: 340px;
        }

        .p4 {
            position: absolute;
            width: 200px;
            bottom: 0;
            left: 0;
        }

        .fyt_back {
            position: absolute;
            width: 80px;
            left: 0;
            top: 60px;
        }
    }

    .hyl-p1box {
        width: 100%;
        height: 100vh;
        // background: url("../static/hyl_picturebox.png") no-repeat;
        // background-size: 100% 100%;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;

        .picturebox {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
        }

        .title1 {
            position: absolute;
            height: 35px;
            left: 85px;
            top: 48px;
        }

        .hyl_picturebox {
            position: absolute;
            left: 40px;
            top: 100px;
            width: 280px;
            height: 75vh;

            overflow: hidden;
            overflow-y: auto;
            .title{
                width: 100%;
                margin-top: 15px;
                margin-bottom: 20px;
            }
            .picture {
                width: 100%;
                display: block;
                margin-bottom: 20px;
                box-sizing: border-box;
                border: 4px #fff solid;

            }

        }

        .back {
            position: fixed;
            left: 0;
            bottom: 0;
            width: 60%;
            left: 50%;
            z-index: 2;
            margin-left: -30%;
        }
    }

    .hyl-p2box {
        width: 100%;
        height: 100vh;
        // background: url("../static/hyl_picturebox.png") no-repeat;
        // background-size: 100% 100%;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;

          .picturebox {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
        }

        .title2 {
            position: absolute;
            height: 35px;
            left: 85px;
            top: 48px;
        }

        .hyl_picturebox {
            position: absolute;
            left: 40px;
            top: 100px;
            width: 280px;
            height: 75vh;

            overflow: hidden;
            overflow-y: auto;
               .title{
                width: 100%;
                margin-top: 15px;
                margin-bottom: 20px;
            }
            .picture {
                width: 100%;
                display: block;
                margin-bottom: 20px;
                box-sizing: border-box;
                border: 4px #fff solid;

            }

        }

        .back {
            position: fixed;
            left: 0;
            bottom: 0;
            width: 60%;
            left: 50%;
            z-index: 2;
            margin-left: -30%;
        }
    }

    .hyl-p3box {
        width: 100%;
        height: 100vh;
        // background: url("../static/hyl_picturebox.png") no-repeat;
        // background-size: 100% 100%;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
          .picturebox {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
        }

        .title3 {
            position: absolute;
            height: 16px;
            left: 75px;
            top: 55px;
        }

        .hyl_picturebox {
            position: absolute;
            left: 40px;
            top: 100px;
            width: 280px;
            height: 75vh;

            overflow: hidden;
            overflow-y: auto;

            .picture {
                width: 100%;
                display: block;
              
                box-sizing: border-box;
                border: 4px #fff solid;

            }
            .picturets{
                margin-top: 8px;
                width: 100%;
                  margin-bottom: 20px;
            }

        }

        .back {
            position: fixed;
            left: 0;
            bottom: 0;
            width: 60%;
            left: 50%;
            z-index: 2;
            margin-left: -30%;
        }
    }

    .hyl-p4box {
        width: 100%;
        height: 100vh;
        // background: url("../static/hyl_picturebox.png") no-repeat;
        // background-size: 100% 100%;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;

          .picturebox {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
        }

        .title4 {
            position: absolute;
            height: 20px;
            left: 130px;
            top: 55px;
        }

        .hyl_picturebox {
            position: absolute;
            left: 40px;
            top: 100px;
            width: 280px;
            height: 75vh;

            overflow: hidden;
            overflow-y: auto;

            .picture {
                width: 100%;
                display: block;
                box-sizing: border-box;
                border: 4px #fff solid;

            }
              .picture1 {
                width: 100%;
                display: block;
                margin-bottom: 20px;
                box-sizing: border-box;
                border: 4px #fff solid;

            }
                .picture24 {
                width: 100%;
                display: block;
                box-sizing: border-box;
                border: 4px #fff solid;

            }
              .picturets{
                margin-top: 8px;
                width: 100%;
                  margin-bottom: 20px;
            }
            .picturets24{
            margin-top: 8px;
                width: 100%;
                  margin-bottom: 20px;
            }

        }

        .back {
            position: fixed;
            left: 0;
            bottom: 0;
            width: 60%;
            left: 50%;
            z-index: 2;
            margin-left: -30%;
        }
    }
}
</style>
